import { useRef } from 'react'

/**
 * Keeps the latest `value` in a ref whose identity never changes, so callbacks that read `ref.current`
 * stay stable across renders while always seeing the current value. Assigns during render (not in an
 * effect) so there is no one-commit lag.
 *
 * Use for values a stable callback needs to read but should not depend on (e.g. the selected truck read
 * inside a memoized click/hover handler that must not re-create on every selection).
 */
export const useLatestRef = <T>(value: T) => {
    const ref = useRef(value)
    ref.current = value
    return ref
}
